import { render, staticRenderFns } from "./list.component.vue?vue&type=template&id=438e1c33&scoped=true"
import script from "./list.component.vue?vue&type=script&lang=js"
export * from "./list.component.vue?vue&type=script&lang=js"
import style0 from "./list.component.vue?vue&type=style&index=0&id=438e1c33&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "438e1c33",
  null
  
)

export default component.exports